import { render, staticRenderFns } from "./anComicCard.vue?vue&type=template&id=689709c6"
import script from "./anComicCard.vue?vue&type=script&lang=js"
export * from "./anComicCard.vue?vue&type=script&lang=js"
import style0 from "./anComicCard.vue?vue&type=style&index=0&id=689709c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports